/**
 * Utility to handle unlimited free ads
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import Config from '../../Config';
import JobsPostAdRequest from '../jobsPostAdRequest';
import { getProtocol, getParams } from '../../../utils';
import { API_BASE_URL, UNLIMITED_FREE_ADS_PAYMENT_API } from '../../../constants/apiEndpoints';
import root from 'window-or-global';
import FetchHelper from '../../FetchHelper';


export default class UnlimitedFreeAds {
	//static details for initial load. These get updated on getting context
	static details = {
		price: 99,
		duration: 20,
		unlockCount: 200,
    	maxFreeAdLimit: 100,
		paymentFailureMessage: 'Something went wrong!! Please try again',
		paymentSuccessMessage: 'Successfully purchased Unlimited Free Ads Pack'
	};

	static getPrice = () => UnlimitedFreeAds.details.price;

	static setPrice = (price) => {
		UnlimitedFreeAds.details.price = price;
	};

	static getDuration = () => UnlimitedFreeAds.details.duration;

	static setDuration = (duration) => {
		UnlimitedFreeAds.details.duration = duration;
	};

	static getUnlockCount = () => UnlimitedFreeAds.details.unlockCount;

	static setUnlockCount = (unlockCount) => {
		UnlimitedFreeAds.details.unlockCount = unlockCount;
	};

  static getMaxFreeAdLimit = () => UnlimitedFreeAds.details.maxFreeAdLimit;

	static setMaxFreeAdLimit = (maxFreeAdLimit) => {
	  UnlimitedFreeAds.details.maxFreeAdLimit = maxFreeAdLimit;
  };

	static updateDetails = (store) => {
		let jobsUnlimitedFreeAdsStaticDetails = Config.get('jobsUnlimitedFreeAdsStaticDetails', store);
		UnlimitedFreeAds.setPrice(jobsUnlimitedFreeAdsStaticDetails.price);
		UnlimitedFreeAds.setDuration(jobsUnlimitedFreeAdsStaticDetails.duration);
		UnlimitedFreeAds.setUnlockCount(jobsUnlimitedFreeAdsStaticDetails.maxApplicationLimit);
		UnlimitedFreeAds.setMaxFreeAdLimit(jobsUnlimitedFreeAdsStaticDetails.maxFreeAdLimit);
	};

	static isEnabled = (city, store) => {
		let jobsUnlimitedFreeAdsEnabledCities = Config.get('jobsUnlimitedFreeAdsEnabledCities', store);
		return ((-1 !== jobsUnlimitedFreeAdsEnabledCities.indexOf('All')) || (-1 !== jobsUnlimitedFreeAdsEnabledCities.indexOf(city.toLowerCase())));
	};

  static redirectToPayment = (packId) => {
  	JobsPostAdRequest.showLoader();
  	JobsPostAdRequest.savePostAdRequest(JobsPostAdRequest.getPostAdRequest());
  	root.location = getProtocol() + API_BASE_URL + UNLIMITED_FREE_ADS_PAYMENT_API + `?packId=${packId}`;
  };

	static getPaymentSuccessMessage = () => UnlimitedFreeAds.details.paymentSuccessMessage;

	static getPaymentFailureMessage = () => UnlimitedFreeAds.details.paymentFailureMessage;

  static handlePaymentResponse = () => {
    if (!root.location) {
      return;
    }
    let params = getParams(root.location.search);
    let message = '';
    if (params.hasOwnProperty('txnId')) {
      message = UnlimitedFreeAds.getPaymentSuccessMessage();
    } else if(params.hasOwnProperty('failed')) {
      message = UnlimitedFreeAds.getPaymentFailureMessage();
    }

    JobsPostAdRequest.showSnackbar(message);
  };
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/others/unlimitedFreeAd.js